module.exports = __webpack_public_path__ + "media/images/flags/1x1/niu-2c19fe92615397583093000f7bc841a2.svg";